import { useParams } from "react-router-dom";
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import locations from "../../../Data/International/FeaturedDestination";
import itineraries from "../../../Data/International/Specific";
import { useEffect } from 'react';
 
const Specific = () => {
  const { region } = useParams();
// Flatten the grouped object to a single array
const allLocations = Object.values(locations).flat();
const location = allLocations.find(loc => loc.id === region);
const itinerary = itineraries[region];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!location) return <div className="text-center mt-10">Location not found.</div>;
  return (
    <div className="max-w-5xl mx-auto px-6 mt-44 mb-20">
      <h1 className="text-3xl font-bold text-yellow-700 mb-4 text-center">{location.title}</h1>

      {/* Carousel with all itinerary images at top */}
      {location && (
        <div className="w-full rounded-xl shadow mb-8 overflow-hidden">
        <Carousel
          showThumbs={false}
          infiniteLoop
          autoPlay
          interval={3000}
          transitionTime={1000}
          stopOnHover={false}
          showStatus={false}
          showArrows={false}
          swipeable={false}
          emulateTouch={false}
          showIndicators={false}
          className="w-full"
        >
          {location.images.map((image, i) => (
            <div key={i}>
              <img
                src={image}
                alt={`Image ${i + 1}`}
                className="w-full h-[300px] sm:h-[400px] md:h-[500px] object-cover"
              />
            </div>
          ))}
        </Carousel>
      </div>
      
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <h2 className="text-xl font-semibold">About this place</h2>
          <p className="mt-2 text-gray-700">{location.description}</p>

          <h2 className="mt-6 text-xl font-semibold">Region</h2>
          <p className="text-gray-700">{location.region}</p>

          <h2 className="mt-6 text-xl font-semibold">Start Point</h2>
          <p className="text-gray-700 ">{location.Startpoint}</p>

          <h2 className="mt-6 text-xl font-semibold">End Point</h2>
          <p className="text-gray-700 ">{location.Endpoint}</p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">Features</h2>
          <ul className="list-disc list-inside text-gray-700 space-y-1">
            {location.features.map((feature, i) => (
              <li key={i}>{feature}</li>
            ))}
          </ul>
        </div>
      </div>

      {/* Itinerary Text Content (no images) */}
      {itinerary && (
        <div className="mt-10">
          <h2 className="text-2xl font-bold text-center mb-6">Itinerary Details</h2>
          <div className="space-y-8">
            {itinerary.map((day, i) => (
              <div key={i} className="bg-yellow-50 p-4 rounded-lg shadow">
                <h3 className="text-xl font-semibold">{day.day}: {day.title}</h3>
                <p className="text-gray-700 mt-2">{day.content}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Specific;
